import React, { useState, useMemo, useImperativeHandle } from 'react'
import styles from './index.scss'
import DpBusinessPopup from '@/libs/components/DpBusinessComponents/DpBusinessPopup'
import DpButtonReset from '@/libs/components/DpUiComponents/DpButtonReset'
import { CheckCircleFill } from 'antd-mobile-icons'
import { transformItem } from './utils'
import isEqual from 'lodash/isEqual'

interface IDpPickerProps {
  columns: any[]
  title?: string
  onChange?: Function
  placeholder?: string
  onRef?: any
  value?: string
  customStyles?: React.CSSProperties
}

const PickCell = (props) => {
  return (
    <div
      className={styles['dp-picker-cell']}
      key={props?.item?.value}
      onClick={() => props?.onChange?.(props?.item)}
    >
      <div className={styles['dp-picker-cell--title']}>
        {props?.item.label}
      </div>
      <div className={styles['dp-picker-cell--icon']}>
        {props?.check ? (
          <CheckCircleFill className={styles['dp-picker-cell--icon-yes']} />
        ) : (
          <span className={styles['dp-picker-cell--icon-round']}></span>
        )}
      </div>
    </div>
  )
}

const View: React.FC<IDpPickerProps> = (props) => {
  const initValue = props?.value ? (typeof props?.value === 'string' ? props?.value?.split?.(',') : props?.value) : []
  const [currentValue, updateCurrentValue] = useState(initValue)
  const [visible, updateVisible] = useState(false)
  const setUpdateVisible = () => {
    updateVisible(true)
    updateCurrentValue(initValue)
  }
  //用useImperativeHandle暴露一些外部ref能访问的属性
  useImperativeHandle(props.onRef, () => {
    return {
      setUpdateVisible,
    }
  })
  const isCheckAll = useMemo(() => {
    const _isEqual = isEqual(currentValue, props?.columns?.map(item => item?.value))
    return _isEqual
  }, [props?.columns, currentValue])

  return (
    <DpBusinessPopup
      title={props?.title || '请选择'}
      visible={visible}
      {...props}
      onClose={() => updateVisible(!visible)}
      headerStyle={{ borderBottomWidth: 0, color: 'var(--third-text-color)', background: `var(--page-bg-color, #f5f6f8)`, }}
      popupBodyStyles={{ ...props?.customStyles, minHeight: props?.columns?.length * 60 + 120, backgroundColor: 'var(--page-bg-color, #f5f6f8)' }}
      containerStyles={{ ...props?.customStyles, padding: '0px 16px', minHeight: props?.columns?.length * 60 + 10, margin: '0 10px 10px', backgroundColor: 'var(--content-bg-color, #fffff)', borderRadius: 16 }}
      footer={
        <div style={{ backgroundColor: 'var(--content-bg-color, #fffff)', padding: '10px 10px 0' }}>
          <DpButtonReset
            style={props?.customStyles}
            confirmProps={{
              onClick: () => {
                props?.onChange?.(currentValue)
                updateVisible(!visible)
              }
            }}
            resetProps={{
              onClick: () => {
                updateCurrentValue?.([])
              }
            }}
          />
        </div>
      }
    >
      <div style={props?.customStyles}>
        <PickCell
          key={'all'}
          item={{
            label: '全选',
            value: 'all'
          }}
          value={currentValue}
          check={isCheckAll}
          onChange={() => {
            if (isCheckAll) {
              updateCurrentValue?.([])
            } else {
              updateCurrentValue?.(props?.columns?.map(item => item?.value))
            }
          }}
        />
        {props?.columns?.map((_) => {
          const item = transformItem(_)
          const isCheck = currentValue?.includes?.(item?.value)
          return (
            <PickCell
              key={item?.value}
              item={item}
              check={isCheck}
              onChange={() => {
                if (isCheck) {
                  updateCurrentValue?.((pve) =>(pve || [])?.filter((key) => key !== item?.value))
                } else {
                  updateCurrentValue?.((pve) => (pve || [])?.concat([item?.value]))
                }
              }}
            />
          )
        })}
      </div>
    </DpBusinessPopup>
  )
}

export default View
